import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import axios from "axios";
import VeeValidate from "vee-validate";
import VueSwal from "vue-swal";
import VueNoty from "vuejs-noty";

// Test API
// axios.defaults.baseURL = "http://sic-be.test/api/";

// Production API
axios.defaults.baseURL = "http://api.sustainabilityinnocenter.com/api/";

Vue.config.productionTip = false;

Vue.use(Argon);
Vue.use(VeeValidate);
Vue.use(VueSwal);
Vue.use(VueNoty, {
  theme: "sunset",
  layout: "topRight",
  progressBar: false,
  timeout: false,
  closeWith: ["click"]
});

new Vue({
  router,
  axios,
  render: h => h(App)
}).$mount("#app");
